var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "w-80 border-t-4 border-light-purple p-4 rounded-lg bg-pure-white relative"
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "py-8 space-y-4" }, [
        _c(
          "div",
          {
            staticClass:
              "flex items-center justify-center content-center flex-wrap gap-x-2 gap-y-3 h-84"
          },
          _vm._l(_vm.promptGetBoxes(), function(prompt) {
            return _c("div", { key: prompt.id, staticClass: "space-y-1" }, [
              _c(
                "div",
                {
                  staticClass:
                    "relative rounded-3xl w-20 h-20 flex-shrink-0 flex items-center justify-center border",
                  style: {
                    backgroundColor:
                      _vm.promptColors[prompt.color].primaryColor,
                    borderColor: _vm.promptColors[prompt.color].secondaryColor,
                    color: _vm.promptColors[prompt.color].textColor
                  }
                },
                [
                  _c("div", { staticClass: "text-xs absolute top-0" }, [
                    _vm._v(_vm._s(prompt.abbreviation))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-5xl font-bold" }, [
                    _vm._v("+")
                  ])
                ]
              ),
              _vm._v(" "),
              _vm._m(1, true)
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm.promptPageCount > 1
          ? _c(
              "div",
              { staticClass: "flex gap-2 items-center justify-center" },
              _vm._l(_vm.promptPageCount, function(n) {
                return _c("button", {
                  key: n,
                  staticClass:
                    "w-2 h-2 rounded-full border border-light-purple outline-none",
                  class: n - 1 === _vm.promptPageIndex ? "bg-light-purple" : "",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.promptPageIndex = n - 1
                    }
                  }
                })
              }),
              0
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.promptPageCount > 1
        ? _c("BlInputButton", {
            staticClass: "absolute rounded-full border border-light-purple",
            style: {
              top: "50%",
              left: "-4rem",
              transform: "translate(0, -50%)"
            },
            attrs: {
              icon: "chevron-left",
              type: "plain",
              disabled: _vm.promptPageIndex === 0
            },
            on: {
              clicked: function($event) {
                _vm.promptPageIndex--
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.promptPageCount > 1
        ? _c("BlInputButton", {
            staticClass: "absolute rounded-full border border-light-purple",
            style: {
              top: "50%",
              right: "-4rem",
              transform: "translate(0, -50%)"
            },
            attrs: {
              icon: "chevron-right",
              type: "plain",
              disabled: _vm.promptPageIndex === _vm.promptPageCount - 1
            },
            on: {
              clicked: function($event) {
                _vm.promptPageIndex++
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "space-y-2" }, [
      _c("div", { staticClass: "h-4 w-16 rounded-full bg-grey-200" }),
      _vm._v(" "),
      _c("div", { staticClass: "h-4 w-64 rounded-full bg-grey-200" }),
      _vm._v(" "),
      _c("div", { staticClass: "h-4 w-48 rounded-full bg-grey-200" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "w-20 h-5 flex items-center justify-center border border-grey-200 rounded"
      },
      [_c("div", { staticClass: "w-6 h-1 rounded bg-grey-200 flex-shrink-0" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64ed5622", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ed5622","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repository/prompting/Preview.vue
// module id = null
// module chunks = 